import { CardTypeTypes } from 'types/Card';
import { ImageDtoType } from 'types/services/magnolia/dtos/ImageDto';
import { OptionalProgramItemsEnum } from 'types/services/magnolia/enums/OptionalProgramItemsEnum';
import { OptionalProgramItemsActionType } from './optionalProgramItems.actionCreators';
import { REQUEST_LOAD_ITEM_FAILURE, REQUEST_LOAD_ITEM_SUCCESS } from './optionalProgramItems.actionTypes';

export const OPTIONAL_ITEM_TYPES = {
	WORKOUT: 'workout',
	RECIPE: 'recipe',
};

export const OPTIONAL_ITEM_ID = {
	[OPTIONAL_ITEM_TYPES.WORKOUT]: 'ITOPTWORKOUT',
	[OPTIONAL_ITEM_TYPES.RECIPE]: 'ITOPTRECIPE',
};

export const OPTIONAL_ITEM_IDS = [
	OPTIONAL_ITEM_ID[OPTIONAL_ITEM_TYPES.WORKOUT],
	OPTIONAL_ITEM_ID[OPTIONAL_ITEM_TYPES.RECIPE],
];

export const mapBackendType = (type: OptionalProgramItemsEnum): CardTypeTypes | undefined => {
	switch (type) {
		case OPTIONAL_ITEM_ID[OPTIONAL_ITEM_TYPES.WORKOUT]:
			return OPTIONAL_ITEM_TYPES.WORKOUT as any;
		case OPTIONAL_ITEM_ID[OPTIONAL_ITEM_TYPES.RECIPE]:
			return OPTIONAL_ITEM_TYPES.RECIPE as any;
		default:
			return undefined;
	}
};

export type OptionalProgramItemsStateType = {
	error?: Error;
	items: {
		[optionalItemKey: string]: {
			title: string;
			text: string;
			previewImage: ImageDtoType;
		};
	};
};

export type RootStateType = {
	optionalProgramItems: OptionalProgramItemsStateType;
};

export const initialState: OptionalProgramItemsStateType = {
	items: {},
};

export default (state: OptionalProgramItemsStateType = initialState, action: OptionalProgramItemsActionType) => {
	switch (action.type) {
		case REQUEST_LOAD_ITEM_SUCCESS:
			return {
				...state,
				items: {
					...state.items,
					error: undefined,
					[action.key]: action.contents,
				},
			};
		case REQUEST_LOAD_ITEM_FAILURE:
			return {
				...state,
				error: action.error,
			};
		default:
			return state;
	}
};
